<template>
  <thead>
    <tr :style="{ backgroundColor: headerBackgroundColor, color: headerForegroundColor }">
      <th
        v-for="column in columns"
        :key="column.id"
        class="p-3 px-4 text-left font-600 border-b-2 border-b-solid border-primary5 whitespace-nowrap min-w-[120px]"
        :class="{ 'cursor-pointer': column.enableSorting }"
        @click="column.enableSorting ? handleSort(column.id) : undefined"
      >
        <div class="flex items-center justify-between gap-2">
          <span>{{ column.header }}</span>
          <template v-if="column.enableSorting && (!isPrintDisplayMode || currentSorting?.id === column.id)">
            <CIcon
              v-if="currentSorting?.id === column.id"
              class="opacity-100"
              :color="headerForegroundColor"
              :icon="currentSorting?.desc ? 'arrow-down' : 'arrow-up'"
              size="16px"
            />
            <CIcon
              v-else-if="!isPrintDisplayMode"
              class="opacity-25"
              :color="headerForegroundColor"
              icon="arrows-up-down"
              size="16px"
            />
          </template>
        </div>
      </th>
    </tr>
  </thead>
</template>

<script setup lang="ts">
import { type ColumnSort } from '@tanstack/table-core'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import useCanvas from '@canvas-builder/composables/useCanvas'

interface Column {
  id: string
  header: string
  enableSorting: boolean
  sortDescFirst?: boolean
}

defineProps<{
  columns: Column[]
  headerBackgroundColor: string
  headerForegroundColor: string
  currentSorting: ColumnSort | null
}>()

const emit = defineEmits<{
  sort: [columnId: string]
}>()

const { isPrintDisplayMode } = useCanvas()

function handleSort(columnId: string) {
  emit('sort', columnId)
}
</script>
